export default "__VITE_ASSET__CYrWvXui__";